import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
// Load Inter font weights actually used (400,500,600,700,800). Avoid 300 since not referenced.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import './index.css'
import { startMocking } from './mocks/browser'

// Start API mocking in development
// Ensure UI still renders if MSW fails to start (e.g., service worker issues, unsupported env)
// Render root (idempotent) helper
const mountApp = () => {
    const rootEl = document.getElementById('root')!
    ReactDOM.createRoot(rootEl).render(
        <React.StrictMode>
            <Suspense fallback={<div className="min-h-screen bg-black" />}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Suspense>
        </React.StrictMode>
    )
}

// Attempt to start mocks, but always mount UI.
// Re-enabled to work with backend API
startMocking().catch(err => {
    // eslint-disable-next-line no-console
    console.warn('[MSW] Failed to start mock service worker:', err)
}).finally(() => {
    mountApp()
})